<template>
	<span class="shp">
			
			<b-modal id="showShareEmailModal" hide-footer body-class="bodypaddingtop" @hidden="resetSelectedItem" :size="tnctemplate==0?'md':'lg'">
				  <template #modal-title> Send Email</template>					
				 <b-container fluid class="p-1">
				  	<b-row class=" mb-2">
						<b-col >						
							<form ref="form" @submit.stop.prevent="handleSubmitEmaitempl">
								
								<b-form-checkbox   v-model="tnctemplate"  name="checkbox-1" value="1"    unchecked-value="0" >Want to use Email Template </b-form-checkbox>
								<b-row v-if="tnctemplate==1">
								<b-col >
									<b-form-group label-for="category-sel" label-size="sm" label-class="mb-0" class="mb-0" :state="emailsendState.template_category" invalid-feedback="category is required!" label="*Category">
									<b-form-select v-model="emailsend.template_category" size="sm" id="category-sel" @change="getCategoryTemplates">
											<b-form-select-option value=""> Select
												Category</b-form-select-option>
											<b-form-select-option v-for="cat in category" :value="cat.id"
												:key="cat.id">{{ cat.template_category }}</b-form-select-option>

										</b-form-select>
									</b-form-group>
								</b-col>
								<b-col >
										<b-form-group v-if="template.length>0" label-for="template-sel" label-size="sm" label-class="mb-0" class="mt-0" :state="emailsendState.template_selected" invalid-feedback="Template is required!" label="*Template">
								<b-form-select v-model="emailsend.template_selected" size="sm" id="template-sel" @change="setSelectedTemplate">
										<b-form-select-option value="0"> Select
											Template</b-form-select-option>
										<b-form-select-option v-for="temp in template" :value="temp.id"
											:key="temp.id">{{ temp.title }}</b-form-select-option>

									</b-form-select>
								</b-form-group>
								</b-col>
								</b-row>
								<b-row>
								<b-col >
								
								
									<b-form-group label-for="subject-input" label-size="sm" label-class="mb-0" class="mt-0" :state="emailsendState.subject" invalid-feedback="Email Subject is required!" label="*Subject">
									<b-form-input id="subject-input" :state="emailsendState.subject" v-model="emailsend.subject"  @focusin="emailsendState.subject = null" size="sm"></b-form-input></b-form-group>
									
									
									<b-form-group label-for="mess-textarea" label-size="sm" label-class="mb-2" class="mb-1" :state="emailsendState.message" invalid-feedback="Message is required!"  label="*Message" >
										<!-- <b-form-textarea v-model="emailsend.message"
										  rows="8"
										  placeholder="Type your message here"
										id="mess-textarea" :state="emailsendState.message"  @focusin="emailsendState.message = null" ></b-form-textarea> -->
									<VueTrix  inputId="mess-textarea"  v-model="emailsend.message" placeholder="Type your message here" :state="emailsendState.message"  @focusin="emailsendState.message = null"/> 
								 <!--<VueTrix class="editor1 w-full" inputId="mess-textarea" v-model="emailsend.message" placeholder="Type your message here" :state="emailsendState.message"  @focusin="emailsendState.message = null" @trix-attachment-remove="handleAttachmentRemove" @trix-attachment-add="handleAttachmentAdd"  />-->
									</b-form-group>
								</b-col>
								</b-row>
								<b-row class="mt-2">
									<b-col class="text-center bankAccountFotmbtnLayout ">
										 <b-button pill type="submit" variant="dark" class="mr-2" style="width: 100px;">Send</b-button>										 
									</b-col>
								</b-row>
								</form>
						</b-col>
						
					</b-row>

				 
				 
				
			<!--<div>Selectedd: {{selectedmess}}</div> -->
				 
				  </b-container>
				  
				  
				</b-modal>


		</span>		
		
</template>
<script>
//import CartVariant from "@/components/cartVariant.vue";
//import ProductRating from "@/components/product-rating.vue";
import VueTrix from "vue-trix";
export default {
  name: 'ShareEmailPopup',
  components: {
  //"cart-variant": CartVariant,
  //"product-rating": ProductRating,
  VueTrix
  },
  props: { 
	userData: { type: Array},	
  },
  mounted(){
    this.inLodcard();
  },
  computed: {
    
  },
  data() {
    return{
		//urlSavebank:this.$root.WEBURL+'savebankProfile',
		sendEmailUrl: this.$root.WEBAPI+'secureapi/sendmessageEmailbulk',
		sendEmailTempUrl: this.$root.WEBAPI+'secureapi/sendmessageEmailTemplatebulk',
		templateCateUrl: this.$root.WEBAPI + 'templateapi/getTemplate-cateory',
		getTemplateUrl: this.$root.WEBAPI + 'templateapi/getTemplateByCateory',
		linkComments:'',
		iamiconfor:'',
		category: [],
		template:[],
		tnctemplate:0,
		modelSize:'md',
		emailsend:{
				subject:'',
				message:'',
				template_category:'',
				template_selected:0
				},
		emailsendState:{
			subject:null,
			message:null,
			template_category:null,
			template_selected:null
			
		},	
		emptyItem:{
				subject:'',
				message:'',
				template_category:'',
				template_selected:0
				}
    }
  },
  methods:{
	/* inLodcard(){
		alert('dasd');
	},*/
	resetSelectedItem() {
			var self = this;
			self.tnctemplate=0;
			self.emailsend = Object.assign({}, self.emptyItem);
	},
	inLodcard(){			
			//this.linkComments = this.social_options[this.$root.share.social];
			
			var self = this;
			self.axios.post(self.templateCateUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
					if (response.data.error == 0 || response.data.error == '0') {
						self.category = response.data.result.category;
						self.loading = false;						
					} else if (response.data.error == 9) {
						self.$root.forceLogout(response.data.message);
					}
					//setTimeout(self.initload, 1000*30);
				})
				.catch(function (error) {
					alert(error);
				});
			
			
		},
		getCategoryTemplates(){
			
			var self = this;
			
			self.axios.post(self.getTemplateUrl, {
				accesskey: self.$session.get('access_key'),
				catId:self.emailsend.template_category
			})
			.then(function (response) {
					if (response.data.error == 0 || response.data.error == '0') {
						self.template = response.data.result.template;
						self.loading = false;						
					} else if (response.data.error == 9) {
						self.$root.forceLogout(response.data.message);
					}
					//setTimeout(self.initload, 1000*30);
				})
				.catch(function (error) {
					alert(error);
				});
		},
		setSelectedTemplate(){
			var self = this;
			var tempId = self.emailsend.template_selected;
			self.template.forEach(item => {						
				if(item.id==tempId){				 	
					
					self.emailsend.subject=item.title;
					self.emailsend.message=item.template;
				}
			});
			
		},
		changeMessage(arg){		 
            //console.log('CHANGE MESSAGE '+social_options[$root.share.social]);
            this.linkComments = this.social_options[arg];
			
        },
		checkFormValidityemailtemp(){
			var valid = true;
			
			if(this.tnctemplate==1){
				if(this.emailsend.template_category==''){
					valid = false;
					this.emailsendState.template_category = false;
				}else{
					this.emailsendState.template_category= true;
				}
				
				if(this.emailsend.template_selected==0){
					valid = false;
					this.emailsendState.template_selected = false;
				}else{
					this.emailsendState.template_selected= true;
				}
			
				
			}
			
				if(this.emailsend.subject.length < 3){
					valid = false;
					this.emailsendState.subject = false;
				}else{
					this.emailsendState.subject= true;
				}
				
				if(this.emailsend.message==''){
					valid = false;
					this.emailsendState.message = false;
				}else{
					this.emailsendState.message= true;
				}
			return valid;
			
		},
		handleSubmitEmaitempl(){
						 if (!this.checkFormValidityemailtemp()) {
						return;
						}
						var self = this;
						var emailSendUrl = self.sendEmailUrl;
						if(self.tnctemplate==1){
							emailSendUrl = self.sendEmailTempUrl;
						}
						

						self.axios.post(emailSendUrl, {
							accesskey: self.$session.get('access_key'),
							user_data: self.userData,
							data: self.emailsend,
						}).then(function (response) {
							if(response.data.error == 0 || response.data.error == '0'){
								self.$bvToast.toast(response.data.message, {
										title: 'Email Status',
										toaster: 'b-toaster-bottom-right',
										autoHideDelay: 5000,
										variant: 'success',
										solid: true,
										appendToast: true
								});
								
								self.emailsend={
									subject:'',
									message:''								
									};
								self.emailsendState = {
									subject:null,
									message:null,
								};
								self.$bvModal.hide('showShareEmailModal');
								//self.noAddwallet=0;
								//self.bulkTransferBtn=0;
								//self.initload();
								//self.inLodcard();
								//self.initProfile();
							}else{
								self.error_msg = response.data.message;
								self.$bvToast.toast(response.data.message, {
								title: 'Email',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'danger',
								solid: true,
								appendToast: true
								});
							
							}

						}).catch(function (error) {
								alert(error);
						});
					
						

		},
		handleAttachmentRemove(file){

			console.log(file);
		},
		handleAttachmentAdd(event){
			console.log(event);
		},
				

    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style    lang="scss">
		$whiteColor: #ffffff;
		$blackColor: #000000;
		$themeColor: #a059d9;
		$themeColor2: #8507d6;
		$themeColor3: #b24bf1;
		$redColor: #e61583;
		$grey: #b9b9b9;
		$grey2: #a6a6a6;
		$themeLightColor: #f2e2ff;
		$themeDarkColor: #df007e;

		@mixin setBlackBoldTextStyles() {
		  font-size: 12px;
		  color: $blackColor;
		  font-weight: bold;
		}
	
		#showShareModal {
		.modal-header{
		padding: 8px;
		}
		
	  .selected-products-wrapper {
		.product-wrapper {
		  width: 50%;
		  max-width: 300px;
		  margin-bottom: 45px;

		  .product-img-wrapper {
			width: 120px;
			text-align: center;

			img {
			  max-height: 100px;
			}
		  }

		  .product-content-wrapper {
			width: calc(100% - 120px);
			padding-left: 5px;

			.product-title {
			  @include setBlackBoldTextStyles();
			}

			.remove-product-link {
			  font-size: 14px;
			  color: $grey2;
			}
		  }
		}
	  }
	  .product-share-wrapper {
		margin-top: 24px;
	  }
	  .bodypaddingtop{
		
		padding-top:0px;
		}
	}
	#showShareMessageModal {
		.modal-header{
		padding: 8px;
		}
	  .selected-products-wrapper {
		.product-wrapper {
		  width: 50%;
		  max-width: 300px;
		  margin-bottom: 45px;

		  .product-img-wrapper {
			width: 120px;
			text-align: center;

			img {
			  max-height: 100px;
			}
		  }

		  .product-content-wrapper {
			width: calc(100% - 120px);
			padding-left: 5px;

			.product-title {
			  @include setBlackBoldTextStyles();
			}

			.remove-product-link {
			  font-size: 14px;
			  color: $grey2;
			}
		  }
		}
	  }
	  .product-share-wrapper {
		margin-top: 24px;
	  }
	  .bodypaddingtop{
		
		padding-top:0px;
		}
	}

	#message-textarea {
	  border-color: $themeDarkColor;

	  :focus {
		border-color: $themeColor2;
	  }
	}
	
	.shoppopup>li{
	line-height:15px;
	}
	
	.card{
			margin-bottom: 12px;	
			box-shadow: 0px 0px 1px 0px #c6c6c6;
			
			.card-footer{
				background-color: #fff;
				border-top: 1px solid rgba(0,0,0,.125);
				.spCross{
					    font-size: 14px;
   						color: darkgray;
				}
			}

			.card-body{
				padding: 5px;
				.pImg{
					max-height: max-content;
				}

				.pTitle{
					font-size: smaller;
					font-weight: 200;
					color: #3f414d;
				}
			}
		}
		
		#radio-slots{
		    text-align: center;
			margin-left: 3%;
		}
		.myoption{
				.custom-control{				 
					margin-right: 20px !important;
					color: #515457d1;
				}
			/*.custom-control-inline{		 
				margin-right: 50px !important;
			}*/
		}
	
	.noteMess{
			font-size: 12px;
		}
		
		.sharepopupStardiaplay{ width: 37%;height: 13px;}
		
	/* EDITOR CLASS*/
.trix-toolbar-2{
	font-size: 10px;
}.trix-button-row{
	font-size: 10px;
}
.trix-content{
	height: 199px;
    overflow: scroll;
}

</style>
